import React, { useState } from "react";
import RootLayout from "./root-layout";
import MainImage from "./MainImage";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { HiOutlineMail } from "react-icons/hi";
import { MdPassword } from "react-icons/md";

import axiosInstance from "../../apiInstances/axiosInstance";
import { toast } from "react-toastify";

import useEncryption from "../useEncryption/useEncryption";

const SignUp = () => {
  const navigate = useNavigate();
  const { decryptData } = useEncryption();
  const [signupdata, setSignupData] = useState({
    email: "",
    password: "",
    conformpassword: "",
  });

  const onChangeInput = (e) => {
    // const { name, value } = e.target;
    const value = e.target.value.trim();
    const name = e.target.name;

    setSignupData({
      ...signupdata,
      [name]: value,
    });
  };

  const mydata = {
    email: signupdata?.email,
    password: signupdata?.password,
    conformpassword: signupdata?.conformpassword,
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   const response = await axiosInstance.post("signup_admin", signupdata);
  //   // const data = decryptData(response.data.data);
  //   console.log("signupdata >>>>>>>>> " ,response.data)
  //   try {
  //     if (response.data.status) {
  //       // localStorage.setItem("email", signupdata.email);
  //       console.log(" ------------>",response)
  //       navigate(`/companydetails/:id`);
  //       toast.success(response.data.message);
  //     } else {
  //       toast.error(response.data.message);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // Signup API code
  const handleSubmit = async () => {
    await axiosInstance
      .post("signup_admin", mydata)
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        console.log("=========myData", myData);
        // console.log("=========logToken", myData?.data?.token);
        if (myData?.status) {
          // localStorage.setItem("Token", myData?.data?.token);
          // localStorage.setItem("Role", myData?.data?.userData?.role);
          navigate(`/companydetails/${myData.data.id}`);
          toast.success(myData?.message);
        } else {
          toast.error(myData?.message);
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  function togglePasswordVisibility() {
    setIsPasswordVisible((prevState) => !prevState);
  }
  return (
    <>
      <RootLayout>
        <MainImage className="mt-8" />

        <div className="bg-white w-full max-w-xl rounded-3xl md:mt-16 mt-5 md:p-16 p-5 flex-center flex-col mb-4">
          <h1 className="text-regal-blue font-josefin font-bold  text-4xl mt-5 text-center text-[#294894]">
            Sign Up
          </h1>
          <div className="md:mt-12 mt-8">
            <div>
              <div className="relative mb-6 border w-full rounded-lg ">
                <div className="flex items-center text-[#A9A9A9]">
                  <span>
                    <HiOutlineMail size={25} className=" ml-2" />
                  </span>
                  <input
                    type="email"
                    id="input-group-1"
                    className="form-input-filed font-medium font-sans outline-none w-full py-2 px-2 rounded-lg"
                    placeholder="Email address"
                    name="email"
                    value={signupdata?.email}
                    onChange={onChangeInput}
                  />
                </div>
              </div>
            </div>

            <div>
              <div className="relative mb-6 border w-full rounded-lg">
                <div className="flex items-center text-[#A9A9A9]">
                  <span>
                    <MdPassword size={25} className=" ml-2" />
                  </span>
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    id="input-group-2"
                    className="form-input-filed font-medium font-sans outline-none w-full py-2 px-2 rounded-lg"
                    placeholder="Password"
                    name="password"
                    value={signupdata?.password}
                    onChange={onChangeInput}
                  />
                </div>
                <button
                  className="absolute inset-y-0 right-0 flex items-center px-4 text-[#A9A9A9]"
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? (
                    <AiOutlineEye className="" />
                  ) : (
                    <AiOutlineEyeInvisible />
                  )}
                </button>
              </div>
            </div>

            <div>
              <div className="relative mb-6 border w-full rounded-lg">
                <div className="flex items-center text-[#A9A9A9]">
                  <span>
                    <MdPassword size={25} className=" ml-2" />
                  </span>
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    id="input-group-2"
                    className="form-input-filed font-medium font-sans outline-none w-full py-2 px-2 rounded-lg"
                    placeholder="Confirm Password"
                    name="conformpassword"
                    value={signupdata?.conformpassword}
                    onChange={onChangeInput}
                  />
                </div>
                <button
                  className="absolute inset-y-0 right-0 flex items-center px-4 text-[#A9A9A9]"
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? (
                    <AiOutlineEye />
                  ) : (
                    <AiOutlineEyeInvisible />
                  )}
                </button>
              </div>
            </div>

            <div
              onClick={handleSubmit}
              className="justify-center items-center flex"
            >
              <button className="bg-[#22345C] rounded-lg py-3 mt-8 px-8 font-medium text-lg text-white leading-normal ">
                Sign Up
              </button>
            </div>
          </div>
          {/* <p className="text-sm  text-[#A9A9A9] mt-10  justify-center flex font-medium">
            Don’t have an account ?{" "}
            <Link to="/Signup" className="font-medium text-[#000000] ">
              Sign In
            </Link>
          </p> */}

          <div className="mt-10 sm:text-sm text-xs font-medium font-sans justify-center flex font-josefin">
            <h4 className="text-[#A9A9A9]">
              have an account ?&nbsp;
              <Link to="/signIn">
                <span className="text-[#030239]">Sign In</span>
              </Link>
            </h4>
          </div>

          <div className="flex font-sans text-center mt-7 sm:space-x-3">
            <input
              id="remember"
              aria-describedby="remember"
              type="checkbox"
              className="w-4 h-4 border mt-4 border-gray-300 rounded bg-gray-50 "
              required
            />
            <p className="text-sm text-[#A9A9A9]   sm:flex py-3.5 font-medium">
              I have read, understand and agree to the
              <Link
                to="/"
                className="font-medium text-[#000000] text-[13px] mx-2"
              >
                Privacy Of Policy
              </Link>
            </p>
          </div>
        </div>
      </RootLayout>
    </>
  );
};

export default SignUp;
